module.exports = __webpack_public_path__ + "img/fire.014c8830.svg";